import { studentConceptDataActionTypes as types } from 'Screens_old';
import InitialState from 'Store/InitialState';

export default function studentConceptDataReducer(state = InitialState.studentConceptDataMap, action) {
    switch (action.type) {
        case types.LOAD_STUDENT_CONCEPT_DATA_SUCCESS:
            {
                const { conceptId, data } = action;
                // let studentConceptDataMap = new Map(state);
                // studentConceptDataMap.set(conceptId, data);
                return {
                    ...state,
                    [conceptId]: data,
                };
            }
        default:
            return state;
    }
}